import * as React from 'react';

import SOVQueriesConsumerInsightsInstagram from './instagram/SOVQueriesConsumerInsightsInstagram';

import { INSTAGRAM } from 'modules/insights/sov/utils/sov';

import type {
  SOVGeneralProps,
  SOVQueryEndpoint,
  SOVQuerySave,
  SOVReport
} from 'modules/insights/sov/types';

type Props = {
  report: SOVReport,
  isActionEvent: boolean,
  onUpdateReport: (a: SOVGeneralProps) => void,
  onSaveQuery: (a: SOVQuerySave) => void,
  onUpdateQuery: (b: SOVQueryEndpoint, a: boolean) => void,
  onDuplicateQuery: (a: SOVGeneralProps) => void,
  onDeleteQuery: (a: SOVGeneralProps) => void
};

class SOVQueriesConsumerInsights extends React.PureComponent<Props> {
  renderInstagram(): React.ReactNode {
    const {
      report,
      isActionEvent,
      onUpdateReport,
      onSaveQuery,
      onUpdateQuery,
      onDuplicateQuery,
      onDeleteQuery
    } = this.props;

    return (
      <div className="sov-queries-collabary__instagram">
        <SOVQueriesConsumerInsightsInstagram
          report={report}
          isActionEvent={isActionEvent}
          onUpdateReport={onUpdateReport}
          onSaveQuery={onSaveQuery}
          onUpdateQuery={onUpdateQuery}
          onDuplicateQuery={onDuplicateQuery}
          onDeleteQuery={onDeleteQuery}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    const { report } = this.props;

    return (
      <div className="sov-queries-consumer-insights">
        {
          report.reportType === INSTAGRAM
            && this.renderInstagram()
        }
      </div>
    );
  }
}

export default SOVQueriesConsumerInsights;
